export default {
  profile: {
    months_one: '{{count}} месяц', months_few: '{{count}} месяца', months_many: '{{count}} месяцев', months_other: '{{count}} месяца',
    period: { free: 'бесплатно', trial: 'пробный период', trial5: 'пробный период · 5 дней' },
    method: { card: 'Карта · CloudPayments', crypto: 'Криптовалюта · NOWPayments' },
    offer: { plus: 'до 5 монет · 30 вопросов Orca AI · макро, календарь, прогноз, Price Alerts, X Radar, YouTube', premium: 'до 8 монет · 55 вопросов Orca AI · всё из Plus, OrcaWatch и Wall Street Digests' },
    err: {
      applying: 'Оплата получена. Тариф включается — обычно это занимает до минуты.', pendingReal: 'Платёжная система ещё не подтвердила оплату. Если вы уже оплатили, проверьте ещё раз через пару минут.',
      canceled: 'Оплата отменена. Средства не списаны — можно выбрать тариф снова.', expired: 'Время на оплату истекло. Создайте новый платёж.',
      trialUsed: 'Пробный период Plus уже использован для этого аккаунта.', missing: 'Платёж не найден. Вернитесь к выбору тарифа.',
      pending: 'Оплата пока не подтверждена. Подождите 5 минут и проверьте ещё раз.', failed: 'Оплата не прошла. Средства не списаны — попробуйте снова или выберите другой способ.',
      coinLimit: 'На тарифе {{plan}} — до {{n}} монет.',
    },
  },
};
